import { createContext } from 'react'

const global = createContext()

export default global